import { useQuery, UseQueryResult } from "react-query";
import { useOrganizationMembership } from "../../authentication/hooks";
import { getFloorInventories, getLocationInventories } from "../api";
import { DeskInventoryFiltersGroupedByType } from "../domain";

export function useLocationInventoriesQuery(
  locationId: string,
  floorId: string | undefined
): UseQueryResult<DeskInventoryFiltersGroupedByType[]> {
  const { organization } = useOrganizationMembership();

  const queryKey = floorId
    ? ["floor-inventories", organization.id, floorId]
    : ["location-inventories", organization.id, locationId];

  const queryFn = () =>
    floorId
      ? getFloorInventories(organization.id, floorId)
      : getLocationInventories(organization.id, locationId);

  return useQuery(queryKey, queryFn, {
    refetchOnMount: "always",
    enabled: !!organization?.id && (!!floorId || !!locationId),
  });
}
